'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShowLauncherBadge = undefined;

var _reselect = require('reselect');

var _calculateUnseenThreadsCount = require('../../threads/selectors/calculateUnseenThreadsCount');

var _getIsOpen = require('../../selectors/getIsOpen');

var getShowLauncherBadge = exports.getShowLauncherBadge = (0, _reselect.createSelector)([_getIsOpen.getIsOpen, _calculateUnseenThreadsCount.calculateUnseenThreadsCount], function (isOpen, unseenThreadsCount) {
  return Boolean(!isOpen && !!unseenThreadsCount);
});